import { useCallback } from 'react';
import type { GetUsersParams } from '../../services';

export type UsersListFilter = {
  excludeCommunityId?: string;
  excludeProgramId?: string;
  search?: string;
};

type UsersPaginationParams = {
  cursor?: string;
  limit?: number;
};

export const useGetUsersParameters = () =>
  useCallback(
    ({ filter, pagination }: { filter?: UsersListFilter; pagination?: UsersPaginationParams }): GetUsersParams => ({
      /* eslint-disable @typescript-eslint/naming-convention -- Start: key is defined by Backend API endpoint */
      cursor: pagination?.cursor,
      exclude_community_id: filter?.excludeCommunityId,
      exclude_program_id: filter?.excludeProgramId,
      limit: pagination?.limit,
      scope: 'all',
      search: filter?.search ?? '',
      /* eslint-enable @typescript-eslint/naming-convention -- End: key is defined by Backend API endpoint */
    }),
    [],
  );
